import styled from '@emotion/styled';
import { FORM_COLOR } from '@/pages/Seminar/components/form/formStyles';

/**
 * 공지 분류 칩 — 공지 목록 행과 공지 상세 머리가 함께 쓴다.
 * 서버 분류값은 NOTICE·EVENT 두 가지(core NoticeType). EVENT 만 청록 옅은 바탕, 그 밖(NOTICE·알 수 없는 값)은 회색.
 * 회색 바탕 #F0F3F2 는 폼의 옅은 구분선 토큰(`FORM_COLOR.lineSoft`)과 같은 값이라 그 토큰을 쓴다(칩 전용 회색 토큰이 따로 없음).
 */
const Chip = styled('span', { shouldForwardProp: (prop: string) => prop !== 'event' })<{ event: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    height: 22px;
    padding: 0 8px;
    border-radius: 11px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    background: ${({ event }) => (event ? FORM_COLOR.primarySoft : FORM_COLOR.lineSoft)};
    color: ${({ event }) => (event ? FORM_COLOR.primaryDeep : FORM_COLOR.sub)};

    @media (max-width: 768px) {
        height: 20px;
        padding: 0 7px;
        font-size: 11px;
    }
`;

export const noticeTypeLabel = (noticeType?: string | null): string => (noticeType === 'EVENT' ? '이벤트' : '공지');

const NoticeTypeChip = ({ noticeType }: { noticeType?: string | null }) => (
    <Chip event={noticeType === 'EVENT'}>{noticeTypeLabel(noticeType)}</Chip>
);

export default NoticeTypeChip;
